import { InsertFlowstep } from 'src/services/runtime/insertFlowstep';
import { MappingSymbolsCount, PUSH_FLOWSTEP_RESULT_HEADER } from 'shared/excel/runtime/flowstepExecution';
import { applyLeadConversion } from 'shared/excel/runtime/convertLeads';


export class ConvertLeads extends InsertFlowstep {
  constructor(flowstep, meta, parent) {
    super(flowstep, meta, parent);

    // We don't have 'id' in response. Use 'leadId' instead
    this.resultIndexes.id = this.resultTableHeaders.findIndex(x => x.key === PUSH_FLOWSTEP_RESULT_HEADER.LeadId.key);
  }


  // override InsertFlowstep
  async _applyFlowstepData_(excelHeaders) {
    const { options } = this.flowstep;
    const { batchSize, parallelCount, runSynchronously, conversion } = options;
    const { options: conversionOptions } = conversion;
    
    const { processRow, columnIndexes } = await applyLeadConversion(excelHeaders, conversion, this.applyFnContext);

    this.requestContext = { columnIndexes, processRow };
    this.options = { batchSize, runSynchronously, parallelCount, conversionOptions, };

    return columnIndexes.map(x => MappingSymbolsCount.id);
  }
};

